import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconExternalLinkStyle0 = gravityIconIndividualCss;

const GravityIconExternalLink = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '8fa84eb1c438e906d421b86d4a8c6b2698529d29', color: this.color, size: this.size }, h("svg", { key: '8a12dff60693077e0a7a8da08660095b4b1d1a92', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '5c3b84bbd2b939f5dc58006116803fa26bf583a7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.967 4H17.6c.22 0 .4.18.4.4v5.625a.4.4 0 0 1-.683.284L15.18 8.175l-4.194 4.194a.5.5 0 0 1-.707 0l-.354-.353a.5.5 0 0 1 0-.707l4.194-4.194-2.435-2.432A.4.4 0 0 1 11.967 4ZM17 13h.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-3v11h11v-3a.5.5 0 0 1 .5-.5Z", fill: "currentColor" }))));
    }
};
GravityIconExternalLink.style = GravityIconExternalLinkStyle0;

export { GravityIconExternalLink as gravity_icon_external_link };

//# sourceMappingURL=gravity-icon-external-link.entry.js.map